export * from '@fhs/routing/src/routes/os/[nativeAction]';
export { default } from'@fhs/routing/src/routes/os/[nativeAction]';
